<template>
    <div>
        <div class="container-fluid">
<!--            <div class="row padd-top-10">-->
<!--                <div class="col-md-12">-->
<!--                    <h1 class="main-heading">Manage Loan Applicants</h1>-->
<!--                </div>-->
<!--            </div>-->
            <div class="row">
                <div class="col-md-12">
<!--                    <div class="search-main">-->
<!--                        <form id="search_candidate" @submit.prevent="searchCandForm($event)">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-12">-->
<!--                                    <label class="ep-input-label" for="search_by_name">Search Students</label>-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-4">-->
<!--                                            <div class="form-group">-->
<!--                                                <input type="text" class="form-control dash-input" id="search_by_name"-->
<!--                                                       placeholder="Enter Candidate Name" v-model="sName">-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4">-->
<!--                                            <div class="form-group">-->
<!--                                                <select v-model="sStatus" class="dash-input">-->
<!--                                                    <option value="">Select Status</option>-->
<!--                                                    <option value="0">Pending</option>-->
<!--                                                    <option value="1">Accepted</option>-->
<!--                                                    <option value="2">Rejected</option>-->
<!--                                                </select>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-1">-->
<!--                                            <div class="form-group">-->
<!--                                                <button type="submit" class="ss-button">Search</button>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </form>-->
<!--                    </div>-->
                    <div class="auto-overflow">
                        <div class="auto-scroll">
                            <div class="display-flex position-stick">
<!--                                <div class="check-input df-heading">-->
<!--                                    <label class="check-container">-->
<!--                                        <input type="checkbox" id="candidateSelectAll" v-on:change="checkAll()">-->
<!--                                        <span class="checkmark"></span>-->
<!--                                    </label>-->
<!--                                </div>-->
                                <div class="student df-heading">
                                    <div class="search-description">Candidate Name <a class="underSearch pull-right" @click="showSearch($event)"><i class="fas fa-search"></i> </a> </div>
                                    <div class="search-menu hide-elem"><input type="text" class="form-control" placeholder="Enter Name" v-model="sName" v-on:keyup="validateEnterKey"> <a class="underSearch pull-right" @click="hideSearch($event)"><i class="fas fa-times"></i> </a> </div>
                                </div>
                                <div class="company-width df-heading">
                                    <div class="search-description">College Status <a class="underSearch pull-right" @click="showSearch($event)"><i class="fas fa-search"></i> </a> </div>
                                    <div class="search-menu hide-elem">
                                        <select v-model="sStatus" class="dash-input" @change="filterList()">
                                            <option value="">Select Status</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Accepted</option>
                                            <option value="2">Rejected</option>
                                        </select>
                                        <a class="underSearch pull-right" @click="hideSearch($event)"><i class="fas fa-times"></i> </a> </div>
                                </div>
                                <div class="email-width df-heading">Loan Providers</div>
                                <div class="email-width df-heading">Sanctioned Amount / Processing Amount</div>
                                <div class="course-width df-heading">Course</div>
                                <div class="semester-width df-heading">Semester</div>
                                <div class="uni-roll-width df-heading">Amount Received</div>
                                <div class="uni-roll-width df-heading">Amount Due</div>
                                <div class="uni-roll-width df-heading">Scholarship</div>
                                <div class="email-width df-heading">Loan Purposes</div>
                                <div class="cn-width df-heading">Phone</div>
                                <div class="email-width df-heading">Email</div>
                            </div>
                            <div class="display-flex" v-for="(item, index) in items">
<!--                                <div class="check-input">-->
<!--                                    <label class="check-container">-->
<!--                                        <input type="checkbox" name="candiatesList" v-on:change="individualCheck()" v-bind:data-key="item.user_other_details_enc_id">-->
<!--                                        <span class="checkmark"></span>-->
<!--                                    </label>-->
<!--                                </div>-->
                                <div class="student">
                                    <div class="dis-table">
                                        <div class="table-cand-icon">
                                            <img v-bind:src="item.image" alt="">
                                        </div>
                                        <div class="table-cand-name">{{item.applicant_name}}</div>
                                    </div>
                                </div>
                                <div class="company-width">
                                    <span v-if="item.status == 0">Pending</span>
                                    <span v-else-if="item.status == 1">Accepted</span>
                                    <span v-else-if="item.status == 2">Rejected</span>
                                </div>
                              <div class="email-width list-data">
                                <span v-for="pr in item.assignedLoanProviders" v-html="pr.provider_name"></span>
                              </div>
                                <div class="email-width list-data">
                                <span v-if="item.loanSanctionReports.length" v-html="item.loanSanctionReports[0].loan_amount"></span>
                              </div>
                                <div class="course-width">{{item.course_name}}</div>
                                <div class="semester-width">{{item.semesters}}</div>
                                <div class="uni-roll-width">
                                    {{item.amount_received}}
                                </div>
                                <div class="uni-roll-width">
                                    {{item.amount_due}}
                                </div>
                                <div class="uni-roll-width">
                                    {{item.scholarship}}
                                </div>
                                <div class="email-width list-data">
                                  <span v-for="pr in item.loanPurposes">{{pr.name}}</span>
                                </div>
                                <div class="cn-width">
                                    <i class="fab fa-whatsapp font-21" @click="actionButton($event)"></i>
                                    <div class="acbtns hidden">
                                        {{item.phone}}
                                    </div>
                                </div>
                                <div class="email-width">
                                    <i class="far fa-envelope font-21" @click="actionButton($event)"></i>
                                    <div class="acbtns hidden">
                                        {{item.email}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="loading-list">
                            <div class="loading-list"></div>
                            <div class="loading-list-ring"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import toastr from  '../../../public/js/toastr.js';
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        components: {

        },
        data() {
            return {
                active: false,
                selectAll: false,
                courses: [],
                sName: '',
                sStatus: '',
                sCompany: '',
                course_name: [],
                semester: [],
                application_type: [],
                items: [],
            }
        },
        methods: {
            getCandidates() {
                showLoader();
                var t = this;
                var url = this.$store.getters.getDomain;

                var filter_data = {
                    'name': t.sName,
                    'college_loan_status': t.sStatus,
                };
                axios.post(`${url}api/v2/loans/manage-loan-applications`, filter_data, {headers: requestHeaders()}).then(function (response) {
                    t.items = response['data']['response']['data'];
                    hideLoader();
                    var checkboxes = document.getElementsByName("candiatesList");
                    for (var i = 0, n = checkboxes.length; i < n; i++) {
                        checkboxes[i].checked = false;
                    }
                });
            },
            filterList() {
                var t = this;
                t.getCandidates();
            },
            searchCandForm() {
                this.getCandidates();
            },
            actionButton(event) {
                var prevElem = document.getElementsByClassName('acbtns');
                var element = event.currentTarget;
                for (var e = 0; e < prevElem.length; e++) {
                    if (!prevElem[e].classList.contains('hidden') && prevElem[e] != element.nextSibling) {
                        prevElem[e].classList.add('hidden');
                    }
                }
                element.nextSibling.classList.toggle("hidden");
            },
            showSearch(e){
                var elem = e.currentTarget;
                elem.parentElement.classList.add('hide-elem');
                elem.parentElement.nextElementSibling.classList.remove('hide-elem');
            },
            hideSearch(e){
                var elem = e.currentTarget;
                elem.parentElement.classList.add('hide-elem');
                elem.parentElement.previousElementSibling.classList.remove('hide-elem');
            },
            validateEnterKey: function(e) {
                if (e.keyCode === 13) {
                    this.filterList();
                }
            },
        },
        mounted() {
            $('.auto-scroll').perfectScrollbar();
            $('.slim-filter').perfectScrollbar();
            $('.coloum-slim').perfectScrollbar();

            var t = this;
            t.filterList();
        }
    }
</script>

<style scoped>
    /* Customize the label (the container) */

    table {
        min-width: 100%;
        border-color: #ddd;
    }

    tr {
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    }

    td {
        padding: 5px 10px;
    }

    .check-container {
        display: block;
        position: relative;
        padding-left: 27px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 16px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .check-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #eee;
        border-radius: 5px;
    }

    /* On mouse-over, add a grey background color */
    .check-container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .check-container input:checked ~ .checkmark {
        background-color: #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .check-container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .check-container .checkmark:after {
        left: 8px;
        top: 5px;
        width: 5px;
        height: 9px;
        border: solid white !important;
        border-width: 0px 2px 2px 0 !important;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .ss-button {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 3px;
    }

    .ss-button:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }
    .main-heading{
        padding-left: 10px;
        margin-left: 10px !important;
    }
    .cn-width i.fa-whatsapp {
        color: #4FCE5D;
    }

    .email-width i.fa-envelope {
        color: #00a0e3;
    }
    .font-21{
        font-size: 21px;
    }
</style>